import {useState} from "react";

export const useModalChat = () => {

  const [visibleModalNewInternalChat, setVisibleModalNewInternalChat] = useState<boolean>(false);
  const [visibleModalSearchUsers, setVisibleModalSearchUsers] = useState<boolean>(false);
  const [visibleModalDeleteInternalChat, setVisibleModalDeleteInternalChat] = useState<boolean>(false);
  const [visibleModalListInternalChatUsers, setVisibleModalListInternalChatUsers] = useState<boolean>(false);
  const [visibleModalInternalChatUpsell, setVisibleModalInternalChatUpsell] = useState<boolean>(false);
  const [visibleModalDiscardImageEditor, setVisibleModalDiscardImageEditor] = useState<boolean>(false);

  return {
    visibleModalNewInternalChat, setVisibleModalNewInternalChat,
    visibleModalSearchUsers, setVisibleModalSearchUsers,
    visibleModalDeleteInternalChat, setVisibleModalDeleteInternalChat,
    visibleModalListInternalChatUsers, setVisibleModalListInternalChatUsers,
    visibleModalInternalChatUpsell, setVisibleModalInternalChatUpsell,
    visibleModalDiscardImageEditor, setVisibleModalDiscardImageEditor,
  }
}
